import FingerprintJS from '@fingerprintjs/fingerprintjs'

let fingerprintPromise = null
let fingerprintId = null

export async function getFingerprintId() {
    if (fingerprintId) {
        return fingerprintId
    }

    if (!fingerprintPromise) {
        fingerprintPromise = FingerprintJS.load()
            .then(fp => fp.get())
            .then(result => {
                fingerprintId = result.visitorId
                return fingerprintId
            })
            .catch((error) => {
                console.error('Fingerprint init error:', error)
                return null
            })
    }

    return fingerprintPromise
}
